var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linkedIn_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5274",
  fill: "#282828",
  d: "M0 0h24v24H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34011"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34007"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34006",
  clipPath: "url(#linkedIn_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13282",
  d: "M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5M8 19H5V8h3ZM6.5 6.732a1.764 1.764 0 1 1 1.75-1.764A1.758 1.758 0 0 1 6.5 6.732M20 19h-3v-5.6c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.4-2.586 7-2.777 7 2.476Z",
  fill: "currentColor"
}))))));
export default SvgLinkedIn;